<div class="flex-column p-40">
    <h1 transloco="error.headline"></h1>
    <span transloco="error.text"></span>
    <span class="error-message" (click)="toggleStacktrace()">
        <div class="stacktrace-toggle">
            <span>{{ message }}</span>
            <mat-icon svgIcon="{{'chevron_down'}}"></mat-icon>
        </div>
        <div *ngIf="showStacktrace" [innerHTML]="stacktrace"></div>
    </span>

    <div class="mt-20 container-buttons">
        <app-primary-button label="error.btHome" (click)="deleteCacheAndReload()"></app-primary-button>
    </div>
</div>
